import React, { useContext, useEffect, useState } from 'react';
import { Paper, Typography, Link } from '@material-ui/core';
import { Link as RouterLink, Redirect, useLocation } from 'react-router-dom';
import { firebaseAuth } from '../provider/AuthProvider';
import { loginDestination, consumeDestination } from '../routing/navigation';

export function AuthRedirect() {
  const { currentUser, loading } = useContext(firebaseAuth);
  const location = useLocation();
  const [destination] = useState(() => loginDestination(location));
  useEffect(() => {
    if (currentUser && !loading) consumeDestination(location);
  }, [currentUser, loading, location]);
  return currentUser && !loading ? <Redirect to={destination} /> : null;
}

export default function AuthPanel({ title, description, children }) {
  const { errors, setErrors } = useContext(firebaseAuth);
  useEffect(() => { setErrors([]); }, [setErrors]);
  return (
    <main style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <Paper elevation={6} style={{ width: '100%', maxWidth: 440, padding: 28, boxSizing: 'border-box' }}>
        <Typography component="h1" variant="h5" style={{ fontWeight: 600, marginBottom: 16 }}>{title}</Typography>
        {description && <Typography style={{ marginBottom: 20 }}>{description}</Typography>}
        {errors.length > 0 && <div role="alert" style={{ color: '#ffb4ab', marginBottom: 16 }}>
          {errors.map((error, index) => <p key={index}>{error}</p>)}
        </div>}
        {children}
        <Typography variant="body2" style={{ marginTop: 24, lineHeight: 1.8 }}>
          Need help? <Link href="mailto:office@21ifm.com">office@21ifm.com</Link><br />
          <Link component={RouterLink} to="/">Back to Options</Link>
        </Typography>
      </Paper>
    </main>
  );
}
